/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from '../services';

interface SwitchResponse {
  data: any; // The actual data
  status: boolean | number; // Success indicator
}

interface SwitchParams {
  // Define the structure of your params here
  [key: string]: any;
}

export const adminActions = {
  getSwitches,
  updateSwitches,
};

function getSwitches(): Promise<any> {
  return services
    .get<SwitchResponse>(`/admin/dashboard/list`)
    .then((promise) => {
      if (promise && 'data' in promise && promise.data.status) {
        return promise.data.data;
      } else {
        // Check for authentication errors
        if (promise?.status === 401) {
          return Promise.reject('Authentication required. Please log in again.');
        } else if (promise?.status === 403) {
          return Promise.reject('Access denied. Admin privileges required.');
        } else {
          return Promise.reject('Error fetching switches');
        }
      }
    })
    .catch((error) => {
      // Handle network or other errors
      if (error?.response?.status === 401) {
        return Promise.reject('Authentication required. Please log in again.');
      } else if (error?.response?.status === 403) {
        return Promise.reject('Access denied. Admin privileges required.');
      } else {
        return Promise.reject(error?.message || 'Error fetching switches');
      }
    });
}

function updateSwitches(id: string | number, params: SwitchParams): Promise<any> {
  return services
    .put<SwitchResponse>(`/admin/dashboard/update/${id}`, params)
    .then((promise) => {
      if (promise && 'data' in promise && promise.data.status) {
        return promise.data;
      } else {
        // Check for authentication errors
        if (promise?.status === 401) {
          return Promise.reject('Authentication required. Please log in again.');
        } else if (promise?.status === 403) {
          return Promise.reject('Access denied. Admin privileges required.');
        } else {
          return Promise.reject('Error updating switches');
        }
      }
    })
    .catch((error) => {
      // Handle network or other errors
      if (error?.response?.status === 401) {
        return Promise.reject('Authentication required. Please log in again.');
      } else if (error?.response?.status === 403) {
        return Promise.reject('Access denied. Admin privileges required.');
      } else {
        return Promise.reject(error?.message || 'Error updating switches');
      }
    });
}
